App.controller('LoginCtrl', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
    $scope.page = 'login';
    $scope.$emit('page', $scope.page);

    $scope.step = '';
    $scope.$emit('step', $scope.step);

    // $scope.redirectToRegister = function () {
    //     $state.go('root.register', {
    //         person: $stateParams.person,
    //         persons: $stateParams.persons,
    //         choose: $stateParams.choose,
    //         prices: $stateParams.prices,
    //         summary: $stateParams.summary,
    //         invitationToken: $stateParams.invitationToken,
    //         redirectToThirdStep: $stateParams.redirectToThirdStep,
    //         redirectLocation: $stateParams.redirectLocation
    //     });
    // };

    $scope.redirectToHealthInsuranceInfo = function() {
        $state.go('root.healthInsuranceInfo.start');
    };

}]);
